module.exports = __webpack_public_path__ + "img/Benfica.2226a03f.png";